import styles from "./NotFound.module.scss";

export default function NotFound() {
  return <div>Not Found</div>;
}
